import { defineStore } from 'pinia'
import { useCurrentUserStore } from './CurrentUserStore';
export const useActionStore = defineStore('actions', {
    state: () => (
        {
            trigger : "",
            actions: [
                {
                    title: "base_data",
                    key : "base_data",
                    show: (parent, data) => {
                        var kooi_id = null;
                        if(data){
                            if(data.kooi_id){
                                kooi_id = data.kooi_id;
                            }
                            if(data.kooi && data.kooi.id){
                                kooi_id = data.kooi.id;
                            }
                            if(parseInt(data.kooi)){
                                kooi_id = parseInt(data.kooi)
                            }
                            parent.$router.push({name:"kooi.kooi-base-data", params : {id : kooi_id, type: 'main'}})
                        }
                        },
                },
                {
                    title: "create_contract",
                    key : "create_contract",
                    show: (parent, data) => {
                        var kooi_id = null;
                        if(data){
                            if(data.kooi_id){
                                kooi_id = data.kooi_id;
                            }
                            if(data.kooi && data.kooi.id){
                                kooi_id = data.kooi.id;
                            }
                            if(parseInt(data.kooi)){
                                kooi_id = parseInt(data.kooi)
                            }
                            if(data && data.order && data.order.latest){
                                parent.$router.push({name:"kooi.order-edit", params : {id : kooi_id, type: 'orders', document_id : 'latest' }})
                            }else{
                                parent.$router.push({name:"kooi.order-edit", params : {id : kooi_id, type: 'orders', document_id : '+' }})
                            }

                        }
                        },
                },
                {
                    title: "send_contract",
                    key : "send_contract",
                    show: (parent, data) => {
                        var kooi_id = null;
                        if(data){
                            if(data.kooi_id){
                                kooi_id = data.kooi_id;
                            }
                            if(data.kooi && data.kooi.id){
                                kooi_id = data.kooi.id;
                            }
                            if(parseInt(data.kooi)){
                                kooi_id = parseInt(data.kooi)
                            }
                            parent.actionStore.trigger = "kooi:offer:menu:send_email"
                            parent.$router.push({name:"kooi.order-edit", params : {id : kooi_id, type: 'orders', document_id : 'latest' }})
                        }
                    },
                },
                {
                    title: "confirm_contract",
                    key : "confirm_contract",
                    show: (parent, data) => {
                            var kooi_id = null;
                            if(data){
                                if(data.kooi_id){
                                    kooi_id = data.kooi_id;
                                }
                                if(data.kooi && data.kooi.id){
                                    kooi_id = data.kooi.id;
                                }
                                if(parseInt(data.kooi)){
                                    kooi_id = parseInt(data.kooi)
                                }

                                parent.actionStore.trigger = "buttons:order:menu:createInvoice" // Create invoice from contract triggern?
                                parent.$router.push({name:"kooi.order-edit", params : {id : kooi_id, type: 'orders', document_id : 'latest' }})
                            }
                        },
                },
                {
                    title: "a_waiting_shinkiba",
                    key : "a_waiting_shinkiba",

                },
                {
                    title: "son_received",
                    key : "son_received",
                    show: (parent, data) => {
                        var kooi_id = null;
                        if(data){
                            if(data.kooi_id){
                                kooi_id = data.kooi_id;
                            }
                            if(data.kooi && data.kooi.id){
                                kooi_id = data.kooi.id;
                            }
                            if(parseInt(data.kooi)){
                                kooi_id = parseInt(data.kooi)
                            }
                            // parent.actionStore.trigger = "" // Create invoice from contract triggern?
                            parent.$router.push({name:"kooi.mycroft-main", params : {id : kooi_id, type: 'mycroft' }})
                        }
                    },
                },
                {
                    title: "pod_received",
                    key : "pod_received",
                    show: (parent, data) => {
                        var kooi_id = null;
                        if(data){
                            if(data.kooi_id){
                                kooi_id = data.kooi_id;
                            }
                            if(data.kooi && data.kooi.id){
                                kooi_id = data.kooi.id;
                            }
                            if(parseInt(data.kooi)){
                                kooi_id = parseInt(data.kooi)
                            }
                            // parent.actionStore.trigger = "" // Create invoice from contract triggern?
                            parent.$router.push({name:"kooi.mycroft-main", params : {id : kooi_id, type: 'mycroft' }})
                        }
                    },
                },
                {
                    title: "create_invoice",
                    key : "create_invoice",
                    show: (parent, data) => {
                        var possibleForCreate = ["outgoing", "sent", "accepted"];
                        var openInvoices = ["open"];
                        var kooi_id = null;
                        if(data){
                            if(data.kooi_id){
                                kooi_id = data.kooi_id;
                            }
                            if(data.kooi && data.kooi.id){
                                kooi_id = data.kooi.id;
                            }
                            if(parseInt(data.kooi)){
                                kooi_id = parseInt(data.kooi)
                            }
                            if(data.sales_type == "direct" || data.sales_type == "direct_trust"){
                                if(data && data.invoice && data.invoice.latest){
                                    parent.$router.push({name:"kooi.invoice-edit", params : {id : kooi_id, type: 'invoices', document_id : 'latest' }})
                                }else{
                                    parent.actionStore.trigger = "buttons:order:menu:createInvoice";
                                    parent.$router.push({name:"kooi.order-edit", params : {id : kooi_id, type: 'orders', document_id : 'latest' }})
                                }
                            }else{
                                if(parent.$store.state.kooi.id == kooi_id){
                                    if(parent.$store.state.kooi && parent.$store.state.kooi.tables && parent.$store.state.kooi.tables.invoices && parent.$store.state.kooi.tables.invoices.length > 0 && openInvoices.includes(parent.$store.state.kooi.tables.invoices[0].status)){
                                        parent.$router.push({name:"kooi.invoice-edit", params : {id : kooi_id, type: 'invoices', document_id : parent.$store.state.kooi.tables.invoices[0].id }})
                                    }else{
                                        if(parent.$store.state.kooi && parent.$store.state.kooi.tables && parent.$store.state.kooi.tables.orders && parent.$store.state.kooi.tables.orders.length > 0 && possibleForCreate.includes(parent.$store.state.kooi.tables.orders[0].status)){
                                            parent.actionStore.trigger = "buttons:order:menu:createInvoice";
                                            parent.$router.push({name:"kooi.invoice-edit", params : {id : kooi_id, type: 'orders', document_id : parent.$store.state.kooi.tables.orders[0].id }})
                                        }
                                        else{
                                            parent.$router.push({name:"kooi.invoice-edit", params : {id : kooi_id, type: 'invoices', document_id : '+' }})
                                        }
                                    }
                                }else{
                                    if(data && data.invoice && data.invoice.latest){
                                        parent.$router.push({name:"kooi.invoice-edit", params : {id : kooi_id, type: 'invoices', document_id : 'latest' }})
                                    }else{
                                        parent.$router.push({name:"kooi.invoice-edit", params : {id : kooi_id, type: 'invoices', document_id : '+' }})
                                    }
                                }
                            }
                        }
                    },
                },
                {
                    title: "send_invoice",
                    key : "send_invoice",
                        show: (parent, data) => {
                            var kooi_id = null;
                            if(data){
                                if(data.kooi_id){
                                    kooi_id = data.kooi_id;
                                }
                                if(data.kooi && data.kooi.id){
                                    kooi_id = data.kooi.id;
                                }
                                if(parseInt(data.kooi)){
                                    kooi_id = parseInt(data.kooi)
                                }
                                parent.actionStore.trigger = "kooi:offer:menu:send_email"
                                parent.$router.push({name:"kooi.invoice-edit", params : {id : kooi_id, type: 'invoices', document_id : 'latest' }})
                            }
                    },
                },
                {
                    title: "pay_invoice",
                    key : "pay_invoice",
                    show: (parent, data) => {
                        var kooi_id = null;
                        if(data){
                            if(data.kooi_id){
                                kooi_id = data.kooi_id;
                            }
                            if(data.kooi && data.kooi.id){
                                kooi_id = data.kooi.id;
                            }
                            if(parseInt(data.kooi)){
                                kooi_id = parseInt(data.kooi)
                            }
                            parent.$router.push({name:"kooi.invoice-edit", params : {id : kooi_id, type: 'invoices', document_id : 'latest' }})
                        }
                    },
                },
                {
                    title: "proforma_paid",
                    key : "proforma_paid",
                    show: (parent, data) => {
                        var kooi_id = null;
                        if(data){
                            if(data.kooi_id){
                                kooi_id = data.kooi_id;
                            }
                            if(data.kooi && data.kooi.id){
                                kooi_id = data.kooi.id;
                            }
                            if(parseInt(data.kooi)){
                                kooi_id = parseInt(data.kooi)
                            }
                            parent.$router.push({name:"kooi.invoice-table", params : {id : kooi_id, type: 'invoices'}})
                        }
                    },
                },
            ],
            loading : false,
        }),
        getters: {
        },
    actions: {
      async get(id){
        const currentUser = useCurrentUserStore();
        this.loading = true;
        return await this.axios.get("/api/v1/" + currentUser.internal_company + "/company/" + id).then((response) => {
            this.loading = false;
            return response.data.data
        });
        this.loading = false;
    },
    },
  })
